// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__RF3hL","fileBtn":"File_fileBtn__2S67W","closeBtn":"File_closeBtn__1whQU","fileSelected":"File_fileSelected__23Edt","disabled":"File_disabled__BJa5T"};